<div class="mb-5">
	<h1 class="h3 m-4">{{'utilization.battlink_ah_return_score_percentage' | translate}} <app-help-tooltip *ngIf="tooltip" [field]="tooltip"></app-help-tooltip></h1>
	<app-score-chart
		*ngIf="data"
		[data]="data"
		[range]="ranges"
		[devices]="devices"
		[hasTruckTypeFilter]="false"
		[hasWorkingDaysFilter]="false"
		[hasCapacityFilter]="hasCapacityFilter"
		[hasVoltageFilter]="hasVoltageFilter"
		[chartMaxValue]="150"
		chartType="battery-ah-return-score"
	></app-score-chart>
</div>
